"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardBox = exports.CARD_BOX_TITLE_SIZE = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _classnames = _interopRequireDefault(require("classnames"));
var _Title = require("./Title");
require("./CardBox.scss");
let CARD_BOX_TITLE_SIZE = exports.CARD_BOX_TITLE_SIZE = /*#__PURE__*/function (CARD_BOX_TITLE_SIZE) {
  CARD_BOX_TITLE_SIZE["default"] = "default";
  CARD_BOX_TITLE_SIZE["large"] = "large";
  return CARD_BOX_TITLE_SIZE;
}({});
const CardBox = _ref => {
  let {
    children,
    dataAttributes,
    titleActions,
    title = null,
    titleSize = CARD_BOX_TITLE_SIZE.default,
    className,
    titleClassName,
    headingClassName
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-CardBox', className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), title && /*#__PURE__*/_react.default.createElement(_Title.Title, {
    titleActions: titleActions,
    titleSize: titleSize,
    className: titleClassName,
    headingClassName: headingClassName
  }, title), children);
};
exports.CardBox = CardBox;
//# sourceMappingURL=CardBox.js.map